import { Workbox } from 'workbox-window';

if ('serviceWorker' in navigator && import.meta.env.PROD) {
    const wb = new Workbox('/sw.js', { scope: '/' });

    wb.addEventListener('waiting', () => {
        wb.messageSkipWaiting();
    });

    wb.addEventListener('controlling', () => {
        window.dispatchEvent(new CustomEvent('pulsar:sw-updated'));
    });

    wb.addEventListener('activated', (event) => {
        if (!event.isUpdate) {
            window.dispatchEvent(new CustomEvent('pulsar:sw-ready'));
        }
    });

    wb.register().catch((err) => {
        console.warn('Service worker registration failed:', err);
    });

    window.__pulsarSW = wb;
}
